import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLang, absoluteUrl, alternateLinks, isLocalizablePath, IS_MULTILINGUAL } from '../i18n';

export const IMAGE_PARTAGE = '/assets_react/minisites/faire-part-mariage-anime-fleurs-bleues-aquarelle.jpg';

// Titre d'onglet : « Titre | Joli Ptit Mot » tant que ça tient dans ce que Google affiche (~65
// caractères) ; au-delà, le titre seul — mieux vaut un titre entier qu'une marque tronquée.
// Au-delà de 70 caractères, on retire la précision qui suit la dernière virgule du titre.
export const titreSeo = (titre, suffixe = ' | Joli Ptit Mot') => {
  if (`${titre}${suffixe}`.length <= 65) return `${titre}${suffixe}`;
  return titre.length > 70 && titre.includes(', ') ? titre.slice(0, titre.lastIndexOf(', ')) : titre;
};

// Description : coupée proprement à la fin d'un mot si elle dépasse ce que Google affiche (~160).
export const descriptionSeo = (texte, max = 160) => {
  const propre = String(texte || '').replace(/\s+/g, ' ').trim();
  if (propre.length <= max) return propre;
  return `${propre.slice(0, max - 1).replace(/[\s,;:.–—-]+\S*$/, '')}…`;
};

// Versions de la page dans chaque langue du site (balises hreflang + x-default = le français).
// Rien tant qu'une seule langue est active, et rien pour les pages qui n'existent pas « par langue »
// (pages de destinataires, administration). À placer dans un <Helmet> : { alternatesFor('/faq') }.
export const alternatesFor = (path) => (IS_MULTILINGUAL && isLocalizablePath(path)
  ? alternateLinks(path).map((a) => <link key={a.hreflang} rel="alternate" hrefLang={a.hreflang} href={a.href} />)
  : null);

// Balises de référencement d'une page : titre, description, adresse de référence (canonical) et
// balises de partage (aperçu du lien dans WhatsApp, Facebook, Messenger…). Sans elles, une page
// hérite de celles de l'accueil (App.js) et se présente donc comme une copie de l'accueil.
// `titre`, `description` : déjà traduits par la page (t('…')). `path` : l'adresse FRANÇAISE de la page
// (« /faire-part-mariage ») : la version de la langue courante s'en déduit (canonical /en/…, hreflang).
const Seo = ({ titre, description, path, image = IMAGE_PARTAGE, suffixe }) => {
  const { lang } = useLang();
  const url = absoluteUrl(path, lang);
  const title = titreSeo(titre, suffixe);
  const desc = descriptionSeo(description);
  const img = image && image.startsWith('http') ? image : absoluteUrl(image);
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      {alternatesFor(path)}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
    </Helmet>
  );
};

export default Seo;
